import React from 'react';
import io from 'socket.io-client';

import HomeScreen from './screens/HomeScreen';
import { getShared, getHrsMinsAmpm, p2, clearFetch, decodeUrlParams } from './vodjs/Utils';
import LogIn from './components/LogIn';
import HallpassLogin from './components/HallpassLogin';
import { noSelect } from './constants/Styles';
import { countForReload } from './vodjs/lib';
import { initElasticLog, elasticLogEvent, elasticLogError } from './vodjs/ElasticLog';
import { getConfig, loadConfig } from './utils/configUtils';
import { featureFlags } from './constants/FeatureFlags';
import { getServerUrl, setMbotConfig } from './constants/Meta';
import Colors from './constants/Colors';
import sleep from 'sleep-promise';

class App extends React.Component {
  
  state = {
    loggedIn: false,
    envLoaded: false,
    willReload: false
  };

  constructor(props) {
    super(props);
    getShared()['homeScreen'] = HomeScreen; //formerly viewmap
  }

  async componentDidMount() {
    try {
      const config = loadConfig();
      await initElasticLog();

      let useHallpass = false; //TODO do this differently once switched over

      let params = decodeUrlParams(config.loadUrl);
      let decodedUrl = decodeURI(config.loadUrl);

      //ask backend if we should use hallpass

      let reachedSrvr = false;
      while(!reachedSrvr) {
        let options = {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({url:decodedUrl})  //todo: do we want to send the non-decoded one? How consumed?
        };

        await clearFetch(`${getConfig().uiSimServer}/useHallpass`, options, {
          success: (json) => {
            useHallpass = !!json.useHallpass;
            reachedSrvr = true;
            setMbotConfig(json);
          },
          bad: ({ logStr }) => elasticLogError({ what: 'useHPErr', msg: `Error asking server whether to use hallpass: ` + logStr })
        });

        if(!reachedSrvr)
          await sleep(1000 * 5);
      }

      if (useHallpass) {
        //check whether server recently said to use legacy
        const legacyNum = Number(params.legacy);
        if (params.legacy && Date.now() < legacyNum) {  //TODO: consider also verifying that legacyNum isn't strangely far into the future
          useHallpass = false;
          elasticLogEvent({ what: 'useLegacy', msg: `Instructed to use legacy` });
        }
      }


      this.setState({ envLoaded: true, useHallpass });

      if (config.kioskSettings) {
        const multibotBackendUrl = getConfig().uiSimServer;
        this.settingsSocket = io.connect(multibotBackendUrl, {
          reconnection: true,
          reconnectionDelay: 500,
          path: '/app/mbotsvc/ws/',
        });
      }

      elasticLogEvent({ what: 'load', msg: `Loaded ${config.version.branch} ${config.version.time}.` });

    }
    catch (err) {
      let loadErr = [{ fontSize: 24, text: 'Load error: ' + (err.message || '' + err) }];

      try {
        let config = loadConfig();
        if (config.version) {
          let { branch, commit, time } = config.version;
          loadErr.push({ fontSize: 16, text: `${branch} / ${(commit || '').slice(0, 8)} / ${time}` });

          let d = new Date();
          let [year, month, date, secs] = [d.getFullYear(), d.getMonth() + 1, d.getDate(), d.getSeconds()];
          let { h, m, ampm } = getHrsMinsAmpm(d.getTime());
          loadErr.push({
            fontSize: 16,
            text: `Load attempted at ${month}/${date}/${year} ${h}:${p2(m)}${ampm}+${secs}s`,
          });
        }
      }
      catch (err) {
        debugger;
      }

      this.setState({ loadErr });
    }
  }

  setUserLoggedIn() {
    this.setState({ loggedIn: true });
  }


  renderLoading() {

    let backgroundColor = this.state.willReload ? Colors.oceanBlue : undefined;
    return (
      <div
        style={{ display: 'flex', width: '100%', height: '100vh', flexFlow: 'column', alignItems: 'center', justifyContent: 'center', backgroundColor }}
        onClick={async () => {
          let willReload = await countForReload();
          if (willReload) this.setState({ willReload });
        }}
      >
        <div style={{ fontStyle: 'italic', ...noSelect }}>Loading...</div>
      </div>
    );
  }

  renderContent() {
    if (this.state.loadErr) {
      let backgroundColor = this.state.willReload ? '#ccfcfc' : undefined;
      return (
        <div
          style={{
            display: 'flex',
            width: '100%',
            height: '100vh',
            flexFlow: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            backgroundColor,
            ...noSelect,
          }}
          onClick={async () => {
            let willReload = await countForReload();
            if (willReload) this.setState({ willReload });
          }}
        >
          {this.state.loadErr.map(({ fontSize, text }) => (
            <div style={{ color: 'red', fontSize, padding: 60 }}>{text}</div>
          ))}
        </div>
      );
    }

    if (!this.state.envLoaded) {
      return this.renderLoading();
    }

    if (!this.state.loggedIn) {
      if (!this.state.useHallpass) {
        return <LogIn setUserLoggedIn={() => this.setUserLoggedIn()} />;
      }
      else {
        return <HallpassLogin setUserLoggedIn={() => this.setUserLoggedIn()} />;
      }
    }

    return <HomeScreen settingsSocket={this.settingsSocket} />;
  }


  render() {
    return this.renderContent();
  }
}

export default App;
